module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Altstaetten-b93be3ae70cb1df7d9809b5e94c387f8.svg";